export default __webpack_public_path__ + "static/media/thumbnail.71ac4d01.png";